import React, { Component } from 'react'
import MUIDataTable from "mui-datatables";
import { IconButton } from '@material-ui/core';
import Launch from '@material-ui/icons/Launch';
import Add from '@material-ui/icons/Add';



export default class CourseTable extends Component {

    constructor(props) {
        super(props);
        this.state = {
            data: [],
            isLoaded: false
        }
    }



    handleDelete(rowsDeleted) {
        console.log(rowsDeleted)
    }

    onActionClick(el){
        this.props.actionClick(el);
    }

    onClick() {
        console.log("hey");
    }



    render() {
        const columns = [
            {
                name: "Name",
                options: {
                    filter: true,
                    sort: true,
                }
            },
            {
                name: "Email",
                options: {
                    filter: false,
                    sort: true,
                }
            },
            {
                name: "Phone",
                options: {
                    filter: true,
                    sort: true,
                }
            },
            {
                name: "Subject",
                options: {
                    filter: true,
                    sort: true,
                }
            },
           
            {
                name: "Message",
                options: {
                    filter: true,
                    sort: true,
                }
            },
            {
                name: "Designation",
                options: {
                    filter: true,
                    sort: true,
                }
            },
            {
                name: "Associated As",
                options: {
                    filter: true,
                    sort: true,
                }
            },
            {
                name: "Date",
                options: {
                    filter: true,
                    sort: true,
                }
            },
           
        ];

        const options = {
            filterType: 'checkbox',
            selectableRows: false,
            onRowsDelete: (rowsDeleted) => {
                this.handleDelete(rowsDeleted)
            },
            customToolbar: () => {
                return (
                    <IconButton><Add onClick={this.props.onAddClick} /></IconButton>
                )
            }
        };

        let data = [];
        let table_data = this.props.table_data;
        if(table_data.length > 0){
            data = table_data.map((el,index)=>
                [el.name,el.email,el.phone,el.subject,el.message,el.designation,el.associated_as == "OTHER" ? el.associated_as_other: el.associated_as,el.date]
            )
        }else{
            data= [];
        }

        return (
            <div>
                <MUIDataTable
                    title={"Feedbacks"}
                    data={data}
                    columns={columns}
                    options={options}

                />
            </div>
        )


    }
}



// WEBPACK FOOTER //
// ./src/Components/Master/Feedbacks/CourseTable.js